import { render, staticRenderFns } from "./KSelectSuggestions.vue?vue&type=template&id=f0040f92&"
import script from "./KSelectSuggestions.vue?vue&type=script&lang=js&"
export * from "./KSelectSuggestions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports